<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="180px">
      <el-form-item
        label="机构名称："
        prop="name">
        <el-input
          v-model="info.name"
          show-word-limit
          :maxlength="32"></el-input>
      </el-form-item>
      <el-form-item
        label="所属行业："
        prop="trade">
        <personal-trade-select v-model="info.trade" />
      </el-form-item>
      <el-form-item
        label="省市区："
        prop="area">
        <area-select v-model="info.area"></area-select>
      </el-form-item>
      <el-form-item
        label="详细地址："
        prop="address">
        <el-input
          v-model="info.address"
          show-word-limit
          :maxlength="50"></el-input>
      </el-form-item>
      <el-form-item
        label="负责人手机号："
        prop="phone">
        <el-input
          v-model="info.phone"
          show-word-limit
          :maxlength="11"></el-input>
      </el-form-item>
      <el-form-item
        label="员工数量："
        prop="accountQuota">
        <el-input-number
          v-model="info.accountQuota"
          :precision="0"
          :min="1"
          :max="1000"></el-input-number>
      </el-form-item>
      <el-form-item
        required=""
        label="开通状态："
        prop="status">
        <el-switch
          v-model="info.status"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item
        required=""
        label="小程序显示涉诉信息："
        prop="wxappShowJudicialCase">
        <el-switch
          v-model="info.wxappShowJudicialCase"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消 </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit"> 确 定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import Verification from '@/service/verification'
import PersonalTradeSelect from '../../components/personal-trade-select.vue'
import AreaSelect from '@/components-v2/area-select.vue'
export default {
  name: 'CorpEditModal',
  components: { PersonalTradeSelect, AreaSelect },
  data() {
    return {
      loading: false,
      visible: false,
      info: { id: null, name: '', phone: '', status: 1, accountQuota: 5, trade: '', address: '', area: [], wxappShowJudicialCase: 1 },
      rules: {
        name: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入负责人手机号', trigger: 'blur' }],
        accountQuota: [{ required: true, message: '请输入最多员工数量', trigger: 'blur' }],
        trade: [{ required: true, message: '请选择所属行业', trigger: 'change' }],
        address: [{ required: true, message: '请输入机构详细地址', trigger: 'blur' }],
        area: [{ required: true, message: '请选择所在省市区', trigger: 'change' }]
      }
    }
  },
  computed: {
    title({ info }) {
      return info.vendorId ? '修改核验机构' : '新增核验机构'
    }
  },
  methods: {
    handleClosed() {
      this.info = { ...this.info, ...this.$options.data().info }
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate()
      }, 20)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { id, area } = this.info
          const [provinceCode, cityCode, areaCode] = area
          Verification[id ? 'updateverificationcorp' : 'addverificationcorp']({ ...this.info, provinceCode, cityCode, areaCode, area: undefined })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('提交成功')
                this.loading = false
                this.visible = false
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    init(options = {}) {
      this.info = { ...this.info, ...options }
      this.visible = true
    }
  }
}
</script>
